import { PanelBody, __experimentalUnitControl as UnitControl} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { VayuBlocksDevice,VayuBlocksDeviceControl } from '@vayu-blocks/device-control';

import {VayuBlocksDimensions, VayuBlocksToggleControl, VayuBlocksRangeControl, 
	VayuBlocksBackground, VayuBlocksAlignment, VayuBlocksColorControl,
	VayuBlocksTypography,VayuBlocksBorder, VayuBlocksSelectControl 
} from '@vayu-blocks';

const Style = ({ attributes, setAttributes, openPanels, onTogglePanel }) => {

	const getView = VayuBlocksDevice();

	const getlayoutCustomWidth = () => {
		switch ( getView ) {
		case 'Desktop':
			return attributes.layoutcustomWidth;
		case 'Tablet':
			return attributes.layoutcustomWidthTablet;
		case 'Mobile':
			return attributes.layoutcustomWidthMobile;
		default:
			return undefined;
		}
	};

	const changelayoutCustomWidth = value => {
		if ( 'Desktop' === getView ) {
			setAttributes({ layoutcustomWidth: value });
		} else if ( 'Tablet' === getView ) {
			setAttributes({ layoutcustomWidthTablet: value });
		} else if ( 'Mobile' === getView ) {
			setAttributes({ layoutcustomWidthMobile: value });
		}
	};

	const getTitleSize = (tag) => {
		switch (tag) {
			case 'h1':
				return 24;
			case 'h2':
				return 18;
			case 'h3':
				return 16;
			case 'h4':
				return 12;
			case 'h5':
				return 10;
			case 'h6':
				return 8;
			default:
				return 16; // default size if the tag doesn't match any case
		}
	};

	const handleTitleTagChange = (value) => {
		const titleSize = getTitleSize(value);
		setAttributes({
			pg_blockTitleTag: value,
			pg_TitleSize: titleSize,
		});
	};


    return (
        <>
			
			<PanelBody title={__('Layout', 'vayu-blocks')} opened={openPanels['Style-layout']}
        onToggle={() => onTogglePanel('Style-layout')}>
				
				<UnitControl
					className='vayu-blcoks-layout-custom-width'
					__next40pxDefaultSize={true}
					__nextHasNoMarginBottom={true}
					label={<VayuBlocksDeviceControl label={__('Column Width', 'vayu-blocks')} />}
					value={ getlayoutCustomWidth() || '' }
					onChange={ changelayoutCustomWidth }
					
					units={[
						{
							a11yLabel: 'Pixels (px)',
							label: 'px',
							step: 1,
							value: 'px',
						},
						{
							a11yLabel: 'Percent (%)',
							label: '%',
							step: 1,
							value: '%',
						},
						{
							a11yLabel: 'Ems (em)',
							label: 'em',
							step: 0.1,
							value: 'em',
						},
					]}
				/>

				<VayuBlocksAlignment
					onChange={(key,value)=>setAttributes({[key]:value})}
					alignment = {{key:'pg_layoutalignment',value:attributes.pg_layoutalignment}}
				/>

				<VayuBlocksRangeControl	
					label={<VayuBlocksDeviceControl label={__('Spacing', 'vayu-blocks')} classname='bold' />}
					min={1}
					max={30}
					marks
					step={3}
					withInputField={false}
					onChange={(key, value) => setAttributes({ [key]: value })}
                    attribute={{key:'spacing', value:attributes.spacing}}
				/>

				<div className='vayu-blocks-dimension-pagination vb-post-grid-typography'>
					<VayuBlocksDimensions  
						onChange={(key,value)=>setAttributes({[key]:value})}
						dimensions = {{padding:{key:'layoutpadding',value:attributes.layoutpadding},}}
					/>
				</div>

				<VayuBlocksBorder 
					onChange={(key,value)=>setAttributes({[key]:value})}
					border={{key:'layoutborder',value:attributes.layoutborder}}
					borderRadius={{key:'layoutradius',value:attributes.layoutradius}}
					dropShadow={{ key: 'layoutShadow', value: attributes.layoutShadow }}
				/>

				<br/>
				<VayuBlocksColorControl 
					onChange={(key,value) => setAttributes({[key]: value})}
					background={{value: attributes.layoutbackground,backgroundKey: "layoutbackground"}}
				/>
				
			</PanelBody>

			<PanelBody title={__('Title', 'vayu-blocks')} opened={openPanels['Style-title']}
        onToggle={() => onTogglePanel('Style-title')}>

				<VayuBlocksSelectControl
					label={__('Title Tag', 'vayu-blocks')}
					value={attributes.pg_blockTitleTag}
					options={[
						{ label: __('H1 Heading h1', 'vayu-blocks'), value: 'h1' },
						{ label: __('H2 Heading h2', 'vayu-blocks'), value: 'h2' },
						{ label: __('H3 Heading h3', 'vayu-blocks'), value: 'h3' },
						{ label: __('H4 Heading h4', 'vayu-blocks'), value: 'h4' },
						{ label: __('H5 Heading h5', 'vayu-blocks'), value: 'h5' },
						{ label: __('H6 Heading h6', 'vayu-blocks'), value: 'h6' },
					]}
					onChange={handleTitleTagChange}
				/>

				<div className="vb-post-grid-typography">
					<VayuBlocksTypography
						value={attributes.titletypography}
						onChange={(newValues) => {setAttributes({titletypography:newValues})}}
					/>
				</div>

				<div className="vb-post-grid-typography">
					<VayuBlocksBackground
						onChange={(key,value)=>setAttributes({[key]:value})}
						colorPanel = {[
							{
								active: ['gradient'],
								label: 'Color',
								key:'pg_TitleColor',
								value:attributes.pg_TitleColor
							},
							{
								active: ['gradient'],
								label: 'Hover',
								key:'pg_TitleColorhvr',
								value:attributes.pg_TitleColorhvr
							}
						]}
					/>
				</div>

			</PanelBody>

			<PanelBody title={__('Content', 'vayu-blocks')} opened={openPanels['Style-content']}
        onToggle={() => onTogglePanel('Style-content')}>

				<div className="vb-post-grid-typography">
					<VayuBlocksTypography
						value={attributes.contenttypography}
						onChange={(newValues) => {setAttributes({contenttypography:newValues})}}
					/>
				</div>

				<div className="vb-post-grid-typography">
					<VayuBlocksBackground
						onChange={(key,value)=>setAttributes({[key]:value})}
						colorPanel = {[
							{
								active: ['gradient'],
								label: 'Color',
								key:'pg_textColor',
								value:attributes.pg_textColor
							}
						]}
					/>
				</div>
			</PanelBody>

			{attributes.expertview?.[getView] && (
				<PanelBody title={__('Content', 'vayu-blocks')} opened={openPanels['Style-excerpt']}
        onToggle={() => onTogglePanel('Style-excerpt')}>

					<div className="vb-post-grid-typography">
						<VayuBlocksTypography
							value={attributes.excetypography}
							onChange={(newValues) => {setAttributes({excetypography:newValues})}}
						/>
					</div>

					<div className="vb-post-grid-typography">
						<VayuBlocksBackground
							onChange={(key,value)=>setAttributes({[key]:value})}
							colorPanel = {[
								{
									active: ['color'],
									label: 'Color',
									key:'exceColor',
									value:attributes.exceColor
								}
							]}
						/>
					</div>
				</PanelBody>
			)}

			<PanelBody title={__('Featured Image', 'vayu-blocks')} opened={openPanels['Style-category']}
        onToggle={() => onTogglePanel('Style-category')}>

				<VayuBlocksToggleControl
                    label={__('Show Featured Image', 'vayu-blocks')}
                    checked={{key:'featuredImage', value:attributes.featuredImage}}
                    onChange={(key, value) => setAttributes({ [key]: value })}
                    responsive={true}
                />

				{attributes.featuredImage?.[getView] && (
					<>
						<VayuBlocksToggleControl
							label={__('Animate on hover', 'vayu-blocks')}
							checked={attributes.pg_featuredimage_animate}
							onChange={(value) => {
								setAttributes({ pg_featuredimage_animate: value });
							}}
						/>
						<div className="vb-post-grid-typography">
							<VayuBlocksBorder 
								onChange={(key,value)=>setAttributes({[key]:value})}
								border={{key:'imageborder',value:attributes.imageborder}}
								borderRadius={{key:'imageradius',value:attributes.imageradius}}
							/>
						</div>

					</>
				)}
			</PanelBody>

			<PanelBody title = {__('Category','vayu-blocks')} opened={openPanels['Style-tags']}
        onToggle={() => onTogglePanel('Style-tags')}> 
				<VayuBlocksToggleControl
                    label={__('Show Categories', 'vayu-blocks')}
                    checked={{key:'categori', value:attributes.categori}}
                    onChange={(key, value) => setAttributes({ [key]: value })}
                    responsive={true}
                />

				{attributes.categori?.[getView] && (
					<>

						<VayuBlocksRangeControl	
							label={<VayuBlocksDeviceControl label={__('Gap', 'vayu-blocks')} classname='bold' />}
							min={1}
							max={30}
							setp={2}
							marks
							withInputField={false}
							onChange={(key, value) => setAttributes({ [key]: value })}
							attribute={{key:'categoryGap', value:attributes.categoryGap}}
						/>

						<div className='vayu-blocks-dimension-pagination vb-post-grid-typography'>
							<VayuBlocksDimensions  
								onChange={(key,value)=>setAttributes({[key]:value})}
								dimensions = {{padding:{key:'categorypadding',value:attributes.categorypadding},}}
							/>
						</div>

						<div className="vb-post-grid-typography">
							<VayuBlocksTypography
								value={attributes.categorytypography}
								onChange={(newValues) => {setAttributes({categorytypography:newValues})}}
							/>
						</div>
						<div className="vb-post-grid-typography">
							<VayuBlocksBackground
								onChange={(key,value)=>setAttributes({[key]:value})}
								colorPanel = {[
									{
										active: ['gradient'],
										label: 'Background',
										key:'category_backgroundColor',
										value:attributes.category_backgroundColor
									},
									{
										active: ['color'],
										label: 'Text',
										key:'pg_categoryTextColor',
										value:attributes.pg_categoryTextColor
									}
								]}
							/>
						</div>
						<div className="vb-post-grid-typography">
							<VayuBlocksBorder 
								onChange={(key,value)=>setAttributes({[key]:value})}
								border={{key:'categoryborder',value:attributes.categoryborder}}
								borderRadius={{key:'categoryradius',value:attributes.categoryradius}}
								dropShadow={{ key: 'categoryShadow', value: attributes.categoryShadow }}
							/>
						</div>

						
										
					</>
				)}
			</PanelBody>

			<PanelBody title = {__('Tags','vayu-blocks')} opened={openPanels['Style-tags']}
        onToggle={() => onTogglePanel('Style-tags')}>
				<VayuBlocksToggleControl
                    label={__('Show Tags', 'vayu-blocks')}
                    checked={{key:'Showtag', value:attributes.Showtag}}
                    onChange={(key, value) => setAttributes({ [key]: value })}
                    responsive={true}
                />

				{attributes.Showtag?.[getView] && (
				<>

						<VayuBlocksRangeControl	
							label={<VayuBlocksDeviceControl label={__('Gap', 'vayu-blocks')} classname='bold' />}
							min={1}
							max={30}
							step={2}
							marks
							withInputField={false}
							onChange={(key, value) => setAttributes({ [key]: value })}
							attribute={{key:'tagGap', value:attributes.tagGap}}
						/>

						<div className="vb-post-grid-typography">
							<VayuBlocksTypography
								value={attributes.tagtypography}
								onChange={(newValues) => {setAttributes({tagtypography:newValues})}}
							/>
						</div>

						<div className="vb-post-grid-typography">
							<VayuBlocksBackground
								onChange={(key,value)=>setAttributes({[key]:value})}
								colorPanel = {[
									{
										active: ['gradient'],
										label: 'Background',
										key:'tag_backgroundColor',
										value:attributes.tag_backgroundColor
									},
									{
										active: ['color'],
										label: 'Text',
										key:'pg_tagTextColor',
										value:attributes.pg_tagTextColor
									}
								]}
							/>
						</div>

						<div className="vb-post-grid-typography">
							<VayuBlocksBorder 
								onChange={(key,value)=>setAttributes({[key]:value})}
								border={{key:'tagborder',value:attributes.tagborder}}
								borderRadius={{key:'tagradius',value:attributes.tagradius}}
								dropShadow={{ key: 'tagShadow', value: attributes.tagShadow }}
							/>
						</div>

						<div className='vayu-blocks-dimension-pagination vb-post-grid-typography'>
							<VayuBlocksDimensions  
								onChange={(key,value)=>setAttributes({[key]:value})}
								dimensions = {{padding:{key:'tagpadding',value:attributes.tagpadding},
							}}
							/>
						</div>
			
			</>)}
			</PanelBody>
		
			<PanelBody title = {__('Meta','vayu-blocks')} opened={openPanels['Style-meta']}
        onToggle={() => onTogglePanel('Style-meta')}>

				<VayuBlocksToggleControl
                    label={__('Show Author', 'vayu-blocks')}
                    checked={{key:'auth', value:attributes.auth}}
                    onChange={(key, value) => setAttributes({ [key]: value })}
                    responsive={true}
                />

				<VayuBlocksToggleControl
                    label={__('Show Date', 'vayu-blocks')}
                    checked={{key:'date', value:attributes.date}}
                    onChange={(key, value) => setAttributes({ [key]: value })}
                    responsive={true}
                />

				{(attributes.auth?.[getView] || attributes.auth?.[getView] )&& (	
				<>

					<div className="vb-post-grid-typography">
						<VayuBlocksTypography
							value={attributes.authortypography}
							onChange={(newValues) => {setAttributes({authortypography:newValues})}}
						/>
					</div>

					<div className="vb-post-grid-typography">
						<VayuBlocksBackground
							onChange={(key,value)=>setAttributes({[key]:value})}
							colorPanel = {[
								{
									active: ['color'],
									label: 'Text',
									key:'pg_authorTextColor',
									value:attributes.pg_authorTextColor
								}
							]}
						/>
					</div>
			</>
		)}
			</PanelBody>
								
        </>
    );
};

export default Style;